import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    entities: {}
};

const requestUserStatistics = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveUserStatistics = (state, action) => {
    return {
        ...state,
        isFetching: false,
        entities: {
            ...state.entities,
            [action.displayName]: action.json
        },
        lastUpdated: action.receivedAt
    };
};

const resetToInitialState = () => INITIAL_STATE;

const handlers = {
    [types.REQUEST_USER_STATISTICS]: requestUserStatistics,
    [types.RECEIVE_USER_STATISTICS]: receiveUserStatistics,
    [types.RESET_USER_STATISTICS]: resetToInitialState
};

export const getUserStatistics = (state) => {
    return state.userStatistics.entities;
};

export default function userStatistics(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
